import { styled } from 'styletron-react';

export const ContentContainer = styled('main', ({ $isCentered = false }) => ({
  textAlign: $isCentered ? 'center' : 'left',
}))
